import { CASE_PHASE, isDriDocumentPhase, resolveCasePhase } from './flowCasePhaseHelper';

const hasMagicFillApplied = (record = {}) => {
  const status = String(record?.ai_fill_status || '').toLowerCase();
  return status === 'proposed' || status === 'accepted';
};

const normalizeRoleKey = (roleKey = '') => {
  const base = String(roleKey || '').toLowerCase();
  if (base.includes('pre-manager') || base.includes('pre-gestor') || base.includes('pregestor')) {
    return 'pre-manager';
  }
  if (base.includes('manager') || base.includes('gestor')) {
    return 'manager';
  }
  return '';
};

export const shouldCollapseDriSections = ({
  record,
  process,
  roleKey,
  flowEnabled
} = {}) => {
  if (!flowEnabled) {
    return false;
  }
  const role = normalizeRoleKey(roleKey);
  if (role === 'pre-manager') {
    const phase = resolveCasePhase(record || {}, {
      roleKey: 'pre-manager',
      process
    });
    if (phase === CASE_PHASE.PROSPECTO || hasMagicFillApplied(record)) {
      return false;
    }
    return true;
  }
  if (role !== 'manager') {
    return false;
  }
  const phase = resolveCasePhase(record || {}, {
    roleKey: 'manager',
    process
  });
  return isDriDocumentPhase(phase);
};

export const getCollapsedSectionHeaderKey = (roleKey) => {
  const role = normalizeRoleKey(roleKey);
  if (role === 'pre-manager') {
    return 'flow.ficha.section.dri-content';
  }
  return 'flow.ficha.section.case-content';
};
